import { Injectable } from '@angular/core';
import { Plugin, registerPlugin } from '@capacitor/core';
import { Store } from '@ngxs/store';
import { HardwareDeviceSelectors } from 'src/app/store/hardware-device/hardware-device.selector';

export interface LocalNetworkAuthResponse {
  granted: boolean;
  message: string;
}

export interface LocalNetworkAuthPlugin extends Plugin {
  requestPermission(): Promise<LocalNetworkAuthResponse>;
}

@Injectable({
  providedIn: 'root'
})
export class IosLocalNetworkAuthService {
  private localNetworkAuthPlugin: LocalNetworkAuthPlugin;

  constructor(private readonly _store: Store) {
    this.localNetworkAuthPlugin = registerPlugin<LocalNetworkAuthPlugin>(
      'LocalNetworkAuthPlugin'
    );
  }

  private get _isIOS() {
    return this._store.selectSnapshot(HardwareDeviceSelectors.isIOS);
  }

  /**
   * Request local network permission on iOS.
   * This will trigger the iOS local network permission dialog.
   * @returns Promise with granted status and message, or null if not on iOS
   */
  async requestPermission(): Promise<LocalNetworkAuthResponse | null> {
    if (!this._isIOS) {
      return null;
    }

    try {
      const result = await this.localNetworkAuthPlugin.requestPermission();
      return result;
    } catch (error) {
      console.error('LocalNetworkAuth: Error requesting permission:', error);
      throw error;
    }
  }
}
